<template>
  <a-modal
    v-model="showModal"
    title="新增黑名单"
    :maskClosable="false"
    :closable="true"
    :destroyOnClose="true">
    <a-form-model
      ref="baseForm"
      :model="formData">
      <a-row>
        <a-col :md="24" :sm="24">
          <a-form-model-item
            label="车牌号"
            prop="licenseNo"
            :rules="{'required':true,'message':' ','trigger':'change'}"
          >
            <a-input v-model="formData.licenseNo" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <template #footer>
      <div class="footer-btn-wrapper">
        <a-button @click="onCancel">取消</a-button>
        <a-button type="primary" :loading="loading" @click="onSubmit">确认</a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import {
  apiSaveOrUpdateBlackLicense
} from '@/api/scp/materialReservationManagement/materialReservation'

export default {
  name: 'AddLicenseModal',
  data () {
    return {
      loading: false,
      showModal: false,
      formData: {
        licenseNo: undefined // 车牌号
      }
    }
  },
  props: {
  },
  methods: {
    show() {
      this.reset()
      this.showModal = true
    },
    // 取消
    onCancel() {
      this.showModal = false
    },
    // 重置
    reset() {
      this.formData = {
        licenseNo: undefined
      }
    },
    // 提交
    onSubmit() {
      this.$refs.baseForm.validate(valid => {
        if(valid) {
          const params = {
            ...this.formData
          }
          this.loading = true
          apiSaveOrUpdateBlackLicense(params).then(res => {
            if (res?.code === 200) {
              this.$message.success('新增成功')
              this.$emit('refreshFun')
              this.showModal = false
            }
          }).finally(() => {
            this.loading = false
          })
        } else {
          this.$message.warning('请检查必填项')
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
